import { useState } from 'react';

export function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setStatus('error');
      setMessage('Please enter your email address.');
      return;
    }
    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const response = await fetch('https://readdy.ai/api/form/d6q5p4ma739gopmlh4o0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (response.ok) {
        setStatus('success');
        setMessage('You\'re in! Expect game day deals and new drops in your inbox.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    } catch {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  return (
    <section className="py-24 px-6 bg-[#f9f7f5]">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-12">
          <div className="w-14 h-14 flex items-center justify-center bg-red-50 rounded-2xl mx-auto mb-6">
            <i className="ri-mail-send-line text-[#6B0000] text-2xl"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">
            Join the Bulldogs Squad
          </h2>
          <p className="text-gray-500 text-base mb-8 max-w-md mx-auto">
            Get exclusive deals, new Bulldogs drops, and game day style tips delivered straight to your inbox.
          </p>

          <form
            id="newsletter-signup-form"
            data-readdy-form
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-5 py-3.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#6B0000] transition-colors"
                disabled={status === 'loading'}
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-7 py-3.5 bg-[#6B0000] text-white font-bold rounded-xl hover:bg-[#850000] transition-colors disabled:opacity-50 whitespace-nowrap text-sm"
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>

            {status === 'success' && (
              <div className="mt-4 p-3 bg-green-50 text-green-700 rounded-xl text-sm font-medium border border-green-200">
                {message}
              </div>
            )}
            {status === 'error' && (
              <div className="mt-4 p-3 bg-red-50 text-red-700 rounded-xl text-sm font-medium border border-red-200">
                {message}
              </div>
            )}
          </form>

          <p className="text-gray-400 text-xs mt-5">No spam. Unsubscribe anytime. Hail State! 🐾</p>
        </div>
      </div>
    </section>
  );
}
